import React, { useEffect, useState } from "react";
import {
  Alert,
  Button,
  Field,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
} from "../../../design-system";
import { createOvertimeRequest } from "../../../helpers/kronaly_helper";

const NewRequestModal = ({ open, employeeProfileId, onClose, onCreated }) => {
  const [minutes, setMinutes] = useState("");
  const [openRequest, setOpenRequest] = useState(false);
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open) {
      setMinutes("");
      setOpenRequest(false);
      setNote("");
      setError(null);
    }
  }, [open]);

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!employeeProfileId) {
      setError("No se pudo determinar tu ficha de empleado en este workspace.");
      return;
    }
    setSaving(true);
    setError(null);
    try {
      const payload = { employee_profile_id: employeeProfileId };
      if (!openRequest) {
        const n = parseInt(minutes, 10);
        if (!Number.isInteger(n) || n < 1) {
          throw new Error("Indica los minutos solicitados o marca solicitud abierta.");
        }
        payload.minutes_requested = n;
      }
      if (note.trim()) payload.note = note.trim();
      const r = await createOvertimeRequest(payload);
      onCreated(r?.data ?? r);
      onClose();
    } catch (err) {
      setError(typeof err === "string" ? err : err?.message || "No se pudo crear la solicitud.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="Nueva solicitud de horas extra" size="md">
      <form onSubmit={onSubmit}>
        <ModalBody>
          {error && <div className="kr-mb-3"><Alert tone="danger">{error}</Alert></div>}
          <p className="kr-text-muted kr-fs-12 kr-mb-4">
            Indica cuántos minutos extra necesitas o deja la solicitud abierta para que el manager
            decida la cantidad.
          </p>

          <label
            className="kr-flex kr-items-center kr-gap-2 kr-mb-3"
            style={{ cursor: "pointer", fontSize: 13 }}
          >
            <input
              type="checkbox"
              checked={openRequest}
              onChange={(e) => setOpenRequest(e.target.checked)}
              style={{ width: 16, height: 16, accentColor: "var(--kr-action)" }}
            />
            <span>Solicitud abierta (sin cantidad fija)</span>
          </label>

          <Field label="Minutos solicitados" style={{ marginBottom: 12 }}>
            <Input
              type="number"
              min={1}
              value={minutes}
              onChange={(e) => setMinutes(e.target.value)}
              disabled={openRequest}
              placeholder="Ej: 60"
              required={!openRequest}
            />
          </Field>

          <Field label="Nota (opcional)">
            <Input
              type="textarea"
              rows={3}
              maxLength={1000}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Justificación o contexto"
            />
          </Field>
        </ModalBody>
        <ModalFooter>
          <Button variant="secondary" type="button" onClick={onClose}>
            Cancelar
          </Button>
          <Button variant="primary" type="submit" disabled={saving}>
            {saving && <Spinner size={12} color="#fff" />}
            Enviar solicitud
          </Button>
        </ModalFooter>
      </form>
    </Modal>
  );
};

export default NewRequestModal;
